import { jsx } from "@emotion/react/jsx-runtime";
import { Autocomplete as Autocomplete$1 } from "@mui/material";
import { forwardRef } from "react";
import { X, ChevronDown } from "react-feather";
import { deepmerge } from "../../utils/deepmerge.js";
import { menuPaperStyles } from "../Menu/Menu.styles.js";
import { autocompleteStyles, closeIconStyles, autoCompleteMenuStyles } from "./Autocomplete.styles.js";
const Autocomplete = forwardRef(function Autocomplete2({
  slotProps,
  ...props
}, ref) {
  const mergedSlotProps = deepmerge({
    paper: {
      sx: menuPaperStyles
    },
    popper: {
      sx: autoCompleteMenuStyles
    }
  }, slotProps);
  return /* @__PURE__ */ jsx(Autocomplete$1, { css: autocompleteStyles, ref, clearIcon: /* @__PURE__ */ jsx(X, { size: 16, css: closeIconStyles }), popupIcon: /* @__PURE__ */ jsx(ChevronDown, {}), slotProps: mergedSlotProps, ...props });
});
Autocomplete.displayName = "Autocomplete";
export {
  Autocomplete
};
//# sourceMappingURL=Autocomplete.js.map
